import React from "react";
import "./KeyInfo.scss";
import {MDBBox, MDBTypography} from "mdbreact";
import SectionHeader from "../SectionHeader/SectionHeader";
import {Fade} from 'react-reveal'
import {assetUrl} from "../../serviceApi";
import Skeleton from "react-loading-skeleton";

const InfoIcon = assetUrl + "images/key-info-icon.svg";

class KeyInfo extends React.Component {
	render() {
		return (
			<MDBBox className="key-information-section">
				<SectionHeader heading={"Key Information"} image={InfoIcon} viewmore={false}/>
				{
					this.props.componentLoading ?
						<Skeleton width={'100'} height={'327px'}/>
						:
						<MDBBox className="key-info-wrapper">
							{
								this.props.key_info.map((item, index) => {
									return (

										<MDBBox className="key-wrapper" key={index}>
											{/*<Fade bottom>*/}
												<MDBTypography tag="p"
											                            className="key-title">{item.title}</MDBTypography>
											{/*</Fade>*/}
											{/*<Fade bottom>*/}
												<MDBTypography tag="p"
											                            className="key-value">{item.value}</MDBTypography>
											{/*</Fade>*/}
										</MDBBox>

									);
								})
							}
						</MDBBox>
				}

			</MDBBox>
		);
	}
}

export default KeyInfo;
